import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMapMarkedAlt, FaCalendarAlt, FaConnectdevelop, FaGraduationCap } from 'react-icons/fa';
import RichText from '../ui/RichText';
import '../../css/common/ProspectiveStudentCard.css';

const ProspectiveStudentCard = ({ opportunity, onTourClick, onGetConnectedClick }) => {
  const navigate = useNavigate();

  const getIcon = (iconType) => {
    switch (iconType) {
      case 'tour':
        return <FaMapMarkedAlt />;
      case 'shabbaton':
        return <FaCalendarAlt />;
      case 'connect':
        return <FaConnectdevelop />;
      case 'fyshh':
        return <FaGraduationCap />;
      default:
        return <FaMapMarkedAlt />;
    }
  };

  const handleCardClick = (e) => {
    // Don't trigger if clicking the button/link
    if (e.target.tagName === 'A' || e.target.closest('a')) {
      return;
    }
    
    if (opportunity.external) {
      window.open(opportunity.link, '_blank', 'noopener,noreferrer');
    } else if (onTourClick && opportunity.title === "Schedule a Tour") {
      onTourClick();
    } else if (onGetConnectedClick && opportunity.title === "Get Connected") {
      onGetConnectedClick();
    } else if (opportunity.link) {
      navigate(opportunity.link);
    }
  };

  const handleLinkClick = (e) => {
    e.stopPropagation(); // Prevent card click from triggering
    
    if (opportunity.external) {
      e.preventDefault();
      window.open(opportunity.link, '_blank', 'noopener,noreferrer');
    } else if (onTourClick && opportunity.title === "Schedule a Tour") {
      e.preventDefault();
      onTourClick();
    } else if (onGetConnectedClick && opportunity.title === "Get Connected") {
      e.preventDefault();
      onGetConnectedClick();
    } else if (opportunity.link) {
      e.preventDefault();
      navigate(opportunity.link);
    }
  };

  return (
    <div 
      className={`prospective-student-card ${opportunity.featured ? 'featured' : ''} ${opportunity.external ? 'external' : ''}`}
      onClick={handleCardClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="prospective-student-card-header">
        <div className="prospective-student-card-icon">
          {getIcon(opportunity.icon)}
        </div>
        <h3 className="prospective-student-card-title">{opportunity.cardTitle || opportunity.title}</h3>
      </div>
      
      <RichText value={opportunity.description} className="prospective-student-card-description" />
      
      <a 
        href={opportunity.link} 
        className="prospective-student-card-link"
        onClick={handleLinkClick}
        target={opportunity.external ? "_blank" : undefined}
        rel={opportunity.external ? "noopener noreferrer" : undefined}
      >
        {opportunity.linkText}
      </a>
    </div>
  );
};

export default ProspectiveStudentCard; 